import React from 'react'
import { Col, FormGroup, FormText, Label, InputGroup, FormFeedback, Input } from 'reactstrap'

import Select from 'react-select'
import 'react-select/dist/react-select.css'

export const SimpleInput = ({ placeholder, name, input, label, type, help, meta: { touched, error } }) => (
  <Input placeholder={placeholder} {...input} type={type} {...(touched && error ? { valid: false } : {})} />
)

export const FieldTxtIcon = ({ prepend, append, name, input, label, type, help, meta: { touched, error } }) => {
  return (
    <FormGroup row>
      <Col md="3">{label && <Label>{label}</Label>}</Col>
      <Col xs="12" md="9">
        <InputGroup>
          {prepend && (
            <div className="input-group-prepend">
              <span className="input-group-text">
                {prepend.icon && <i className={prepend.icon} />}
                {!prepend.icon && prepend}
              </span>
            </div>
          )}
          <Input {...input} type={type} {...(touched && error ? { valid: false } : {})} />
          {append && (
            <div className="input-group-append">
              <span className="input-group-text">
                {append.icon && <i className={append.icon} />}
                {!append.icon && append}
              </span>
            </div>
          )}

          {touched && error && <FormFeedback className="help-block">{error}</FormFeedback>}
          {help && <FormText className="help-block">{help}</FormText>}
        </InputGroup>
      </Col>
    </FormGroup>
  )
}

export const FieldTxt = ({
  disabled,
  name,
  input,
  label,
  type,
  help,
  bsSize,
  placeholder,
  id,
  meta: { touched, error }
}) => (
  <FormGroup row>
    <Col md="3">{label && <Label>{label}</Label>}</Col>
    <Col xs="12" md="9">
      <Input
        {...input}
        id={id}
        bsSize={bsSize}
        placeholder={placeholder}
        disabled={disabled}
        type={type}
        {...(touched && error ? { valid: false } : {})}
      />
      {touched && error && <FormFeedback className="help-block">{error}</FormFeedback>}
      {help && <FormText className="help-block">{help}</FormText>}
    </Col>
  </FormGroup>
)

export const FieldCheckbox = ({ name, input, label, type, meta: { touched, error } }) => {
  return (
    <FormGroup row>
      <Col md="3"></Col>
      <Col xs="12" md="9" style={{ display: 'flex' }}>
        <div style={{ marginRight: 10 }}>
          <input {...input} type="checkbox" />
        </div>
        <div style={{ flex: 1 }}>
          <label htmlFor={name}>{label}</label>
          {touched && error && <span className={'error-txt'}>{error}</span>}
        </div>
      </Col>
    </FormGroup>
  )
}

export const FieldSelect = ({
  nullValue,
  required,
  help,
  options,
  name,
  input,
  label,
  type,
  meta: { touched, error }
}) => {
  return (
    <FormGroup row>
      <Col md="3">{label && <Label>{label}</Label>}</Col>
      <Col xs="12" md="9">
        <Input type="select" {...input} className={`form-control ${touched && error ? 'is-invalid' : ''}`}>
          {!required && <option value={null}>{nullValue}</option>}
          {options.map((option, index) => (
            <option value={option.value} key={index}>
              {option.name}
            </option>
          ))}
        </Input>
        {touched && error && <FormFeedback className="help-block">{error}</FormFeedback>}
        {help && <FormText className="help-block">{help}</FormText>}
      </Col>
    </FormGroup>
  )
}

export const FieldSelectWithOptGroup = ({
  nullValue,
  required,
  help,
  options,
  name,
  input,
  label,
  type,
  meta: { touched, error }
}) => {
  return (
    <FormGroup row>
      <Col md="3">{label && <Label>{label}</Label>}</Col>
      <Col xs="12" md="9">
        <Input type="select" {...input} className={`form-control ${touched && error ? 'is-invalid' : ''}`}>
          {!required && <option value={null}>{nullValue}</option>}
          {options.map((option, groupIndex) => {
            return (
              <optgroup label={`${option.name}`} key={groupIndex}>
                {option.options.map((option, index) => (
                  <option value={option.value} key={index}>
                    {option.name}
                  </option>
                ))}
              </optgroup>
            )
          })}
        </Input>
        {touched && error && <FormFeedback className="help-block">{error}</FormFeedback>}
        {help && <FormText className="help-block">{help}</FormText>}
      </Col>
    </FormGroup>
  )
}

export const FieldSelect2 = ({ multi, help, options, name, input, label, type, meta: { touched, error } }) => (
  <FormGroup row>
    <Col md="3">{label && <Label>{label}</Label>}</Col>
    <Col xs="12" md="9">
      <Select
        options={options}
        multi={true}
        {...input}
        onChange={value => {
          return input.onChange(value.map(p => p.value))
        }}
        onBlur={() => {
          input.onBlur([...input.value])
        }}
      />
      {touched && error && <FormFeedback className="help-block">{error}</FormFeedback>}
      {help && <FormText className="help-block">{help}</FormText>}
    </Col>
  </FormGroup>
)

export const FieldSelect2Bis = ({ multi, help, options, name, input, label, type, meta: { touched, error } }) => (
  <FormGroup row>
    <Col md="3">{label && <Label>{label}</Label>}</Col>
    <Col xs="12" md="9">
      <Select
        options={options}
        multi={true}
        {...input}
        onChange={value => {
          return input.onChange(value)
        }}
        onBlur={() => {
          input.onBlur([...input.value])
        }}
      />
      {touched && error && <FormFeedback className="help-block">{error}</FormFeedback>}
      {help && <FormText className="help-block">{help}</FormText>}
    </Col>
  </FormGroup>
)



// WEBPACK FOOTER //
// ./src/components/Form/wh-field.js